/*
 |--------------------------------------------------------------------------
 | Old kind of crappy code
 | TODO: Most of the code below belongs to a zebra, this is module specific
 | So consider moving this js to the module component later when it is built.
 |--------------------------------------------------------------------------
 */

import headerModule from './modules/header'

window.jQuery(document).ready(function ($) {
    /* Initialize the header */
    headerModule()

    $('.zebra__slider__inner-section .row').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 200,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    })


    let $window = $(window)
    let $card2 = $('.zebra__posts .row')
    let toggleSlick

    toggleSlick = function () {
        $card2.not('.slick-initialized').slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            dots: true,
            arrows: false,
            speed: 200,
            responsive: [

                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        arrows: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: 'unslick'
                }
            ]
        })
    }
    $window.resize(toggleSlick)
    toggleSlick()

    $('.album__section').lightGallery({
        mode: 'lg-fade',
        thumbnail: false,
        autoplay: false,
        pager: false,
        autoplayControls: false,
        download: false,
        fullScreen: false,
        zoom: false,
        share: false,
        counter: false,
        selector: '.album__section a',
        speed: 100
    })
    $('.project-details__slider').slick({ dots: true, arrows: true, infinite: true, speed: 100, fade: true, cssEase: 'linear' })
    $('.project-details__testimonials').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 100,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 2000,
        draggable: false,
        touchMove: false
    })
})

// Text line clamp function to limit the text in the project and newsitems to 2 lines. Timeout of 100ms because the items to be clamped in vue dont work.
setTimeout(function () {
    const lineClampElements = document.querySelectorAll(".line-clamp");

    console.dir(lineClampElements)
    for(let i = 0; i < lineClampElements.length; i++) {
        lineClamp(lineClampElements[i], 2);
    }
}, 100);

